module.exports = __webpack_public_path__ + "static/img/fish52.7b2f338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish52.png
// module id = dUIQ
// module chunks = 0